const $skip = (collection, expr, options) => {
  return collection.drop(expr);
};
export {
  $skip
};
